var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPageBlank = function SvgPageBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 15,
    r: 14.5,
    fill: "#3ABCA8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.917h-4.469V22.5h-7.81c-.398 0-.721-.341-.721-.744V8.244c0-.411.321-.744.717-.744h11.565c.397 0 .718.337.718.756v9.66Zm0 1.25L17.75 22.5v-3.38l3.25.047Z",
    fill: "#fff"
  })));
};

export default SvgPageBlank;